import type { DropdownItemData } from "../components/common/DropdownHelpers";
import { salesforceStore } from "../store/salesforce";

export const NOT_CREATED_DROPDOWN_VALUE = "NOT_CREATED";
export const OPPORTUNITY_NOT_CREATED_DROPDOWN_LABEL = "Opportunity not created";
export const ACTIVITY_NOT_CREATED_DROPDOWN_LABEL = "Activity not created";

export const NO_OPPORTUNITY_DROPDOWN_ITEM: DropdownItemData = {
    value: NOT_CREATED_DROPDOWN_VALUE,
    label: OPPORTUNITY_NOT_CREATED_DROPDOWN_LABEL,
};

export enum OpportunityStatusText {
    OPEN = "Open",
    CLOSED_WON = "Closed Won",
    CLOSED_LOST = "Closed Lost",
}

export const NO_ACTIVITY_DROPDOWN_ITEM: DropdownItemData = {
    value: NOT_CREATED_DROPDOWN_VALUE,
    label: ACTIVITY_NOT_CREATED_DROPDOWN_LABEL,
};

export const DAYS_INTERVAL_FOR_SF_ACTIVITY_QUERY = 60;

/**
 * Gets the country code from Salesforce context
 */
export const getCountryCodeFromSfContext = (): string => {
    return salesforceStore.getState().sfContext.locale || "";
};
